<template>

<section class="bg-light advantages pt-5">
    <div class="container">

        <div v-if='isReady' class="row justify-content-center">
            <div class="col-lg-2 mt-1 text-center text-lg-left mb-3 mb-lg-0">
                <h3 class="text-uppercase"><span class="d-inline d-lg-block">What </span>you get</h3>
            </div>
            <div class="col-lg-2 col-md-3 col-sm-5 col-xs-12">
                <div class="count-box text-center">
                    <span class="count-num">
                        <span class="counter-count">{{ stats.i }}</span>+
                    </span>
                    <p class="text-muted">photos</p>
                </div>
            </div>

            <div class="col-lg-2 col-md-3 col-sm-5 col-xs-12">
                <div class="count-box text-center">
                    <span class="text-gold count-num">
                        <span class="counter-count">{{ stats.v }}</span>+
                    </span>
                    <p class="text-muted">videos</p>
                </div>
            </div>

            <div class="col-lg-2 col-md-3 col-sm-5 col-xs-12">
                <div class="count-box text-center">
                    <span class="count-num">
                        <span class="counter-count">{{ stats.m }}</span>+                            
                    </span>
                    <p class="design-p">models</p>
                </div>
            </div>

            <div class="col-lg-2 col-md-3 col-sm-5 col-xs-12">
                <div class="count-box text-center">
                    <span class="text-gold count-num">
                        <span class="counter-count text-gold">100</span>+
                    </span>
                     <p class="text-muted">
                        new content <br> every day, New Models uploaded daily!
                     </p>
                </div>
            </div>
         
        </div>
    
    </div>
</section>


</template>

<script>
    export default {

        mounted() {

            this.getData();

            // Counters (Home Page Effect)
        
        },

        created() {
           
        },

        data() {
            return {
                isReady : false,
                stats : false
            }
        },

        methods : {

            getData() {
                this.ajax.call('st:wug', {}, (r) => {
                    
                    if( r.status == 'success' ) {
                        this.stats = r.data;
                        this.isReady = true;

                        this.$nextTick( () => {
                            $('.counter-count').each(function () {
                                $(this).prop('Counter',0).animate({
                                    Counter: $(this).text()
                                }, {
                                    duration: 5000,
                                    easing: 'swing',
                                    step: function (now) {
                                        $(this).text(Math.ceil(now));
                                    }
                                });
                            });
                        })
                    }

                })
            }

        }

    }
</script>
